import { DateRange } from './dateRange';
import { PaginationFilters } from './paginationFilters';
import { Style } from './style';

export class MediaShareLink {
	id?: string;
	enabled?: boolean;
	creationDate?: Date;
	styles?: Style[];

	constructor(init?: Partial<MediaShareLink>) {
		Object.assign(this, init);
	}
}

export class MediaShareLinkFilters extends PaginationFilters {
	creationDate?: DateRange;
	styleCodes?: string[];
	link?: string;

	constructor(init?: Partial<MediaShareLinkFilters>) {
		super(init);
		Object.assign(this, init);
	}
}
